// Client-side session id: one UUID per browser tab-session, persisted in
// sessionStorage. Sent with client telemetry (error reports, web vitals,
// page views) and threaded through sign-in so audit_log `login` rows carry
// the same id — that join is what makes error-rate-per-session computable
// (only 19/374 errors carried a request_id; request ids are per-request,
// this is per-session).
//
// Deliberately sessionStorage, not localStorage: the id dies with the tab,
// so it can't become a long-lived tracking identifier. Never used for auth.

const KEY = "sl_session_id";

export function getSessionId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    let id = window.sessionStorage.getItem(KEY);
    if (!id || !/^[A-Za-z0-9-]{8,64}$/.test(id)) {
      id = crypto.randomUUID();
      window.sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Storage can be blocked (private mode, iframe policies). Telemetry
    // simply goes session-less rather than breaking the page.
    return null;
  }
}
